import { render, staticRenderFns } from "./QuestionManagement.vue?vue&type=template&id=2307156b&scoped=true&"
import script from "./QuestionManagement.vue?vue&type=script&lang=js&"
export * from "./QuestionManagement.vue?vue&type=script&lang=js&"
import style0 from "./QuestionManagement.vue?vue&type=style&index=0&id=2307156b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2307156b",
  null
  
)

export default component.exports